module.exports = __webpack_public_path__ + "static/media/horton-hears-a-who-logo@2x.5aed40dd.png";